import * as React from "react";
import styled from "styled-components";
import Layout from "../components/Layout";

const Body = styled.div`
  margin-top: 15vh;
  max-width: 600px;
  font-size: calc(1.1875rem);

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    line-height: 2rem;
  }

  p {
    margin-bottom: 1.5rem;
  }

  li {
    margin: 0.5rem;
  }
`;

const IndexPage: React.FC = () => {
  return (
    <Layout pageTitle="Fabio de Sousa">
      <Body>
        <h1>Hello!</h1>
        <p>
          I&apos;m a Software Engineer at{" "}
          <a
            href="https://conserv.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Conserv
          </a>
          . Let&apos;s build things.
        </p>
      </Body>
    </Layout>
  );
};

export default IndexPage;
